import { connect } from "react-redux"
import { bindActionCreators } from "redux"
import { jarvisPrimeDashboardActions } from "stores/jarvisPrime/jarvisPrimeDashboard/jarvisPrimeDashboardActions";

const mapStateToProps = (state) => {
   
    return {
        portfolioOverviewLoading:state.jarvisPrime.primeDashboard.loading.portfolioOverview,
        portfolioOverviewData: state.jarvisPrime.primeDashboard.portfolioOverview,
    }
}

const mapDispatchToProps = (dispatch) => bindActionCreators({
    getPortolioOverviewAction: jarvisPrimeDashboardActions.getPortfolioOverview,
}, dispatch)

const StatsStore = (Container) => connect(mapStateToProps, mapDispatchToProps)(Container);
export default StatsStore;